import { FETCH_PORTAL_FILTERS, UPDATE_FILTERS } from "../constants";
const initialState = {
  selectedTipo: null,
  minPrice: null,
  maxPrice: null,
  minMetrosCuadrados: null,
  maxMetrosCuadrados: null,
  cantidadPisos: "todo",
  cantidadDormitorios: "todo",
  cantidadBanos: "todo",
  ordenar: "",
  currentPage: 1,
  total:0,
  hasMore: false,
  ubicaciones: [],
  proyectos: [],
};
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PORTAL_FILTERS:
      return state;
    case UPDATE_FILTERS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
